import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { getRouteData } from '@mwe/utils';
import { NgClass } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'mwe-header',
  templateUrl: './header.component.html',
  imports: [NgClass, TranslateDirective],
})
export class HeaderComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  @Input() isLongHeader = false;
  @Input() isOrangeHeader = false;
  @Input() hideHeader = false;
  @Input() title: string | undefined;
  @Input() withBottomMargin = true;
  @Input() wideHeader = false;
  routeData: any; // TODO

  ngOnInit(): void {
    this.routeData = getRouteData(this.activatedRoute) || {};
    this.updateClasses();
    this.setPageTitle();
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.routeData = getRouteData(this.activatedRoute) || {};
        this.updateClasses();
        this.setPageTitle();
      }
    });
  }
  updateClasses(): void {
    this.isLongHeader = this.routeData.isLongHeader;
    this.isOrangeHeader = this.routeData.isOrangeHeader;
    this.hideHeader = this.routeData.hideHeader;
  }

  setPageTitle(): void {
    if (this.routeData) {
      this.title = this.routeData.pageTitle;
    }
  }
}
